import {
  AuthenticatedView,
  GiftCardRefundForm,
} from '@aboutyou/logic-components';
import {Redirect} from '@aboutyou/router';
import {COLORS, FullPageSpinner, ModalDialog} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const GiftCardRefundPage = () => {
  return (
    <PageWrapper>
      <ContentWrapper>
        <AuthenticatedView
          context="gift-card-refund-page"
          View={GiftCardRefundForm}
          Loading={FullPageSpinner}
          Fallback={() => <Redirect to="/" />}
          viewProps={{
            layoutComponent: StyledModalDialog,
          }}
        />
      </ContentWrapper>
    </PageWrapper>
  );
};

const ContentWrapper = styled.div`
  max-width: 600px;
  margin: 0 auto;
`;

const StyledModalDialog = styled(ModalDialog)`
  & > #modalContent {
    width: 600px;
  }
`;

const PageWrapper = styled.div`
  min-height: 100vh;
  background-color: ${COLORS.Grey5};
`;
